import { createSelector } from 'reselect'
import * as R from 'ramda'

import * as baseSelectors from './base'

export const recentNudgesSelector = createSelector(
  baseSelectors.boardSelector,
  R.propOr([], '@board/recent-nudges')
)
